import { render, staticRenderFns } from "./VTaskStatus.vue?vue&type=template&id=735c71db&"
import script from "./VTaskStatus.vue?vue&type=script&lang=js&"
export * from "./VTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports